module.exports = __webpack_public_path__ + "static/media/060-love.03f1fffd.svg";